import { Card, CardContent } from "@/components/ui/card";
import BusinessProfileHeader from "./profile/BusinessProfileHeader";
import BusinessProfileStats from "./profile/BusinessProfileStats";
import BusinessProfileForm from "./profile/BusinessProfileForm";
import { Database } from "@/integrations/supabase/types";

interface BusinessProfileSectionProps {
  isEditing: boolean;
  categories: string[];
  address: string;
  latitude: number | null;
  longitude: number | null;
  businessName: string;
  businessPhone: string;
  businessWebsite: string;
  businessDescription: string;
  businessImageUrl?: string | null;
  onCategoriesChange: (value: string[]) => void;
  onEditToggle: () => void;
  onSaveProfile: () => void;
  onLocationSelect: (location: { 
    lat: number; 
    lng: number; 
    formattedAddress: string;
    placeId?: string;
    businessDetails?: {
      name?: string;
      phoneNumber?: string;
      website?: string;
      rating?: number;
      userRatingsTotal?: number;
      reviews?: google.maps.places.PlaceReview[];
      photoUrl?: string;
    };
  }) => void;
  onBusinessNameChange: (value: string) => void;
  onBusinessPhoneChange: (value: string) => void;
  onBusinessWebsiteChange: (value: string) => void;
  onBusinessDescriptionChange: (value: string) => void;
}

const BusinessProfileSection = ({
  isEditing,
  categories,
  address,
  latitude,
  longitude,
  businessName,
  businessPhone,
  businessWebsite,
  businessDescription,
  businessImageUrl,
  onCategoriesChange,
  onEditToggle,
  onSaveProfile,
  onLocationSelect,
  onBusinessNameChange,
  onBusinessPhoneChange,
  onBusinessWebsiteChange,
  onBusinessDescriptionChange,
}: BusinessProfileSectionProps) => {
  return (
    <Card className="bg-white/80 backdrop-blur-sm shadow-lg border-0 transition-all duration-300 hover:shadow-xl">
      <BusinessProfileHeader 
        isEditing={isEditing} 
        onEditToggle={onEditToggle} 
      />

      <CardContent className="p-4 sm:p-6">
        <div className="flex flex-col md:flex-row gap-6">
          <BusinessProfileStats 
            businessImageUrl={businessImageUrl}
            isEditing={isEditing}
          />
          <BusinessProfileForm
            isEditing={isEditing}
            categories={categories}
            address={address}
            businessName={businessName}
            businessPhone={businessPhone}
            businessWebsite={businessWebsite}
            businessDescription={businessDescription}
            onCategoriesChange={onCategoriesChange}
            onLocationSelect={onLocationSelect}
            onBusinessNameChange={onBusinessNameChange}
            onBusinessPhoneChange={onBusinessPhoneChange}
            onBusinessWebsiteChange={onBusinessWebsiteChange}
            onBusinessDescriptionChange={onBusinessDescriptionChange}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default BusinessProfileSection;